import React from 'react';
import { motion } from 'framer-motion';
import { Home, Car, Heart, Activity } from 'lucide-react';
const coverageTypes = [{
  icon: Home,
  title: 'Home Insurance',
  description: 'Absolute Insurance Brokers brings you options with your coverage',
  color: 'from-red-500 to-orange-500',
  bgColor: 'bg-red-50',
  iconColor: 'text-red-600'
}, {
  icon: Car,
  title: 'Car Insurance',
  description: 'Absolute Insurance Brokers brings you options with your coverage',
  color: 'from-green-500 to-emerald-500',
  bgColor: 'bg-green-50',
  iconColor: 'text-green-600'
}, {
  icon: Heart,
  title: 'Life Insurance',
  description: 'Absolute Insurance Brokers brings you options with your coverage',
  color: 'from-pink-500 to-rose-500',
  bgColor: 'bg-pink-50',
  iconColor: 'text-pink-600'
}, {
  icon: Activity,
  title: 'Health Insurance',
  description: 'Absolute Insurance Brokers brings you options with your coverage',
  color: 'from-purple-500 to-indigo-500',
  bgColor: 'bg-purple-50',
  iconColor: 'text-purple-600'
}];
export function InsuranceCoverage() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-264">
      <div className="container mx-auto px-4 md:px-6" data-id="element-265">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-266">
          <p className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-4" data-id="element-267">
            What We Provide Our Customers
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-brand-black max-w-4xl mx-auto leading-tight" data-id="element-268">
            We're covering all the{' '}
            <span className="text-brand-red" data-id="element-269">Insurance Fields</span> That You
            Need
          </h2>
        </motion.div>

        {/* Coverage Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-270">
          {coverageTypes.map((coverage, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group" data-id="element-271">
              <div className="bg-white border border-gray-100 rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300 h-full flex flex-col items-center" data-id="element-272">
                {/* Icon Circle */}
                <motion.div whileHover={{
              scale: 1.05,
              rotate: 5
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} className={`w-24 h-24 rounded-full ${coverage.bgColor} flex items-center justify-center mb-6`} data-id="element-273">
                  <coverage.icon className={`w-12 h-12 ${coverage.iconColor}`} strokeWidth={1.5} data-id="element-274" />
                </motion.div>

                {/* Title */}
                <h3 className="text-xl font-bold text-brand-black mb-3" data-id="element-275">
                  {coverage.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-276">
                  {coverage.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}